import ApiClient from 'remote/api-client';

const listLogs = dbid => ApiClient.get(`/databases/${dbid}/logs`).promise();

const getDownloadLink = (dbid: string, logId: string) =>
  ApiClient.get(`/databases/${dbid}/logs/${logId}`).promise();

export default { listLogs, getDownloadLink };
